import "../styles/Footer.css";
import * as React from "react";
import {ToolIcons} from "./Tool";
import {Config} from "../Config";
import {useMemo} from "react";

interface FooterProps {
    isHome : boolean
}
export function Footer(props) {
    const year = new Date().getFullYear();

    // Normalize base public URL once
    const publicUrl = useMemo(() => {
        const base = process.env.PUBLIC_URL || "/";
        // remove trailing slash (except when it's just "/")
        return base.length > 1 ? base.replace(/\/+$/, "") : "/";
    }, []);

    // Build prefix for links
    const getPrefix = useMemo(() => {
        if (props.isHome) {
            // On homepage, use hash-only for in-page anchors
            return "#";
        }
        // From sub-pages, navigate to app root with hash-routing
        // "/" -> "/#"; "/my/app" -> "/my/app/#"
        return (publicUrl === "/" ? "" : publicUrl) + "/#";
    }, [props.isHome, publicUrl]);

    return <footer className="footer section">
        <div className={"header"}>
            <a className="logo" href={process.env.PUBLIC_URL}>
                <img src={process.env.PUBLIC_URL + "/assets/logo.png"} alt={"najsu agency logo"}/>
            </a>

            <p>
                Najsu is an independent design studio crafting websites that deliver results. From custom-built
                sites to ready-to-use Framer templates, we combine strategy, UX, and visual design to help SaaS,
                tech, and lifestyle brands grow with confidence.
            </p>
        </div>
        <div className={"icons"}>
            <a href={Config.SocialsLinks.Twitter} target={"_blank"}>{ToolIcons.Twitter}</a>
            <a href={Config.SocialsLinks.Dribble} target={"_blank"}>{ToolIcons.Dribble}</a>
        </div>
        <div className={"copyright"}>
            <p className={"font-tag-text"}>Copyright <span>©{year} najsu.com</span></p>
            <p className={"font-tag-text"}>Proudly designed IN BRNO {ToolIcons.Hearth}</p>
        </div>
        <div className={"navigation"}>
            <div className={"navigation-column"}>
                <div className={"font-tag-text"}>Navigation</div>
                <a href={getPrefix + Config.PageSections.HowItWorks} className={"link"}>How It Works</a>
                <a href={getPrefix + Config.PageSections.Services} className={"link"}>Services</a>
                <a href={getPrefix + Config.PageSections.Pricing} className={"link"}>Pricing</a>
                <a href={getPrefix + Config.PageSections.Templates} className={"link"}>Framer Templates</a>
                <a href={getPrefix + Config.PageSections.Testimonials} className={"link"}>Testimonials</a>
                <a href={getPrefix + Config.PageSections.FAQ} className={"link"}>FAQ</a>
            </div>
            <div className={"navigation-column"}>
                <div className={"font-tag-text"}>Legal</div>
                <a href={process.env.PUBLIC_URL + Config.PageLinks.TermsAndConditions} className={"link"}>Terms & conditions</a>
                <a href={process.env.PUBLIC_URL + Config.PageLinks.PrivacyPolicy} className={"link"}>Privacy policy</a>
            </div>
            {/*<a href={"#"} className={"link"}>Terms & conditions</a>*/}
            {/*<a href={"#"} className={"link"}>Privacy policy</a>*/}
            {/*<a href={"#"} className={"link"}>Client login</a>*/}


        </div>
    </footer>
}
